import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import GTMRouteTracker from './GTMRouteTracker';
import Login from './login';
import Maintenance from './Maintenance';
import Registration from './Registration';
import Emission from './Emission';
import Questions from './Questions';
import Checkin from './checkin';
import Thanks from './Thanks';
import Dashboard from './Dashboard';
import PanelECJ from './PanelECJ';
import Privacy from './Privacy';
import Debug from './Debug';
import PagoSuccess from './Success';
import PagoFailure from './Failure';
import PagoPending from './Pending';

import { AuthProvider } from "./AuthContext";
import ProtectedRoute from "./ProtectedRoute";

const tagManagerArgs = {
  gtmId: 'GTM-NHXTGXZZ'
};

TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <GTMRouteTracker />
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Maintenance />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/emission" element={<Emission />} />
          <Route path="/questions" element={<Questions />} />
          <Route path="/success" element={<PagoSuccess />} />
          <Route path="/failure" element={<PagoFailure />} />
          <Route path="/pending" element={<PagoPending />} />
          <Route path="/checkin" element={<Checkin />} />
          <Route path="/thanks" element={<Thanks />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/panelecj" element={<ProtectedRoute><PanelECJ /></ProtectedRoute>} />
          <Route path="/debug" element={<ProtectedRoute><Debug /></ProtectedRoute>} />
        </Routes>
      </AuthProvider>
    </Router>
  </React.StrictMode>
);
